import {
  withTranslation,
} from 'react-i18next';

import InputDiscountView from './InputDiscountView';

const TranslatedComponent = withTranslation()(InputDiscountView);

const Component = TranslatedComponent;

export default Component;
